import React from 'reactn'
import { Paper, Button, AppBar, Toolbar, IconButton, Typography, Dialog, Grid, Box, Tabs, Tab, CircularProgress } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { Modal, PillButton, Typography as CommonsTypography } from '@orijinworks/frontend-commons';
import FlagIcon from '@material-ui/icons/Flag';
import GroupIcon from '@material-ui/icons/Group';
import ToggleOn from '@material-ui/icons/ToggleOn';
import ToggleOff from '@material-ui/icons/ToggleOff';
import styles, { deactivateConfirmModalSlotStyles } from './staff-profile.style';
import { withStyles } from '@material-ui/styles'
import { LearnerRelationship } from '../relationship';
import StaffDetails from '../staff-details';
import { setStaffDetails, STAFF_DETAILS, COMMUNICATION_TAB_TYPE, setUserCommunicationContactsData, USER_CONTEXT, setJanusProfileToken, ROLES, SUPER_ADMIN_ROLES } from '../../../../constants';
import RolesAssignments from '../roles-assignments'
import LearnerGroup from "../learner-group/learner-group";
import { UserCommunications as UserCommunication } from '../../../user-communication';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ResponseBox from '../../../response-box';
import { getStaffDetails, getLocationFeatureStatus, activateStaff, deactivateStaff, whiteListStaff, addRolesAssignment } from '../../../../util/APIUtils';
import ManageStaffContainer from '../manage-staff-container';
import { ManagementService } from '../../management.service';
import SisenseDashboard from '../../../../components/sisense-dashboard';
import { isPermitted, PermissionControl } from '../../../permission-control/permission-control';
import { UserIcon } from '../../../UserIcon';
import { getUserIdFromURL } from '../../../../util/Helpers';
import { withUnleash } from '../../../../v2/core/unleash';
import { UnleashService } from '../../../../v2/services';
import UnleashProvider from '../../../../v2/core/unleash/unleashProvider';
import useTabDetailsHook from './useTabDetailsHook';
import StaffPermissionsTab from './staff-permissions-tab';
import { SSOEnabledChip } from './ssoEnabledChip'
import LockPersonOutlined from '@mui/icons-material/LockPersonOutlined';

class StaffProfile extends React.Component {
    _managementService = new ManagementService();
    TABS = {
        Details: 0,
        Communication: 1,
        Relationship: 2,
        Roles: 3,
        Learner_Group: 4,
        Sisense: 5,
        Permissions: 6,
    };

    state = {
        manageStaff: {
            isOpen: false,
            isEdit: false,
            isConfirmationOpen: false,
            data: null,
            statesCollection: [],
            description: null
        },
        isstaffDetailsLoading: false,
        data: STAFF_DETAILS,
        activeTab: this.TABS.Details,
        response: {
            isOpen: false,
            data: [],
            heading: ""
        },
        isLearnerProfile: false,
        staffProfileId: null,
        addFacilityDialogOpen: false,
        /** True when Add Facility dialog was opened from Reactivate User (all facilities inactive, CREATE_STAFF_V2). */
        addFacilityDialogForReactivation: false,
        deactivateConfirmOpen: false,
        staffActivateDeactivateSubmitting: false,
    };

    /**
     * @name handleTabChange
     * @param {number} tabID
     * @desc Handle tab change event.
     * @return {void}
     */
    handleTabChange = (activeTab) => {
        this.setState({ activeTab }, () => {
            const { unleashProps } = this.props;
            if (unleashProps.isFlagEnabled()) {
                this.setHiddenBreadcrumbItems();
            }
        });
    };

    componentWillUnmount() {
        setStaffDetails({});
        setJanusProfileToken("");
        this.setGlobal({ staffProfileID: null });
    };

    getRolesAtLocation = (locations) => {
        const location = locations.find(
            (role) => role.locationId === this.getSelectedLocation
        );
        if (location) {
            return location
                .roleName
                .split(",")
                .map(
                    role => ({
                        locationKey: location.locationId,
                        roleName: role.trim()
                    })
                );
        }
        return [];
    };


    /**
     * POST /staff/reactivate — same payload shape as used in {@link changeStaffStatus} when activating.
     * @param {number|string} personId
     * @param {object[]} [rolesAtLocation=[]]
     * @returns {Promise}
     */
    requestStaffReactivationApi = (personId, rolesAtLocation = []) =>
        activateStaff({
            reactivateRequest: [{ personId, rolesAtLocation }],
        });

    /**
     * Hermes staff whitelist upsert by locations when Auto_Create_Relationships is enabled.
     * @param {number|string} personId
     * @param {Array<{ locationId: number|string, active: boolean }>} locations
     * @returns {Promise<void>}
     */
    requestStaffWhitelistSync = async (personId, locations) => {
        if (!this.state.isAutoCreateAvailable) {
            return;
        }
        const requestPayload = {
            staffPersonId: personId,
            locations: locations.map((location) => ({
                locationId: location.locationId,
                status: location.active,
            })),
        };
        await whiteListStaff(requestPayload);
    };

    /**
     * After Add Facility during full reactivation: Janus assignment, then reactivate user, then whitelist; one profile refresh at the end.
     * @param {{ locationId: number|string, userName: string, roleId: number|string }} assignmentPayload
     * @returns {Promise<void>}
     */
    runReactivationViaAddFacilityFlow = async (assignmentPayload) => {
        const personId = this.state.data.staffDetails.personId;
        await addRolesAssignment(assignmentPayload);
        await this.requestStaffReactivationApi(personId, []);
        const locationsForWhitelist = this.buildLocationsForWhitelistAfterNewFacility(
            assignmentPayload.locationId
        );
        await this.requestStaffWhitelistSync(personId, locationsForWhitelist);
        setStaffDetails({});
        this.setState({
            addFacilityDialogOpen: false,
            addFacilityDialogForReactivation: false,
        });
        await this.getStaffDetails(personId, { softRefresh: true });
    };

    /**
     * @param {number|string} newActiveLocationId — facility just assigned / reactivated
     * @returns {Array<{ locationId: number|string, active: boolean, ... }>}
     */
    buildLocationsForWhitelistAfterNewFacility = (newActiveLocationId) => {
        const fromFacilities = this.state.facilitiesLocations;
        const base =
            Array.isArray(fromFacilities) && fromFacilities.length > 0
                ? fromFacilities.map((l) => ({ ...l }))
                : (this.state.data.locations || []).map((l) => ({ ...l }));
        const idx = base.findIndex((l) => l.locationId === newActiveLocationId);
        if (idx >= 0) {
            base[idx] = { ...base[idx], active: true };
        } else {
            base.push({ locationId: newActiveLocationId, active: true });
        }
        return base;
    };

    /**
     * @name changeStaffStatus
     * @param {boolean} updatedStaffStatus
     * @desc Updates staff status with respect to param. passed.
     * @return {void}
     */
    changeStaffStatus = (updatedStaffStatus) => {
        let requestHandler = null;
        const { staffDetails, locations } = this.state.data;
        let whiteListLocationCollection = [];
        if (updatedStaffStatus) {
            requestHandler = this.requestStaffReactivationApi(
                staffDetails.personId,
                this.getRolesAtLocation(locations)
            );

            const activeLocationIndex = STAFF_DETAILS.locations
                .findIndex(
                    (role) => role.locationId === this.getSelectedLocation
                );
            if (activeLocationIndex > -1) {
                STAFF_DETAILS.locations[activeLocationIndex].active = true;
            }
            whiteListLocationCollection = STAFF_DETAILS.locations;
        } else {
            requestHandler = deactivateStaff({
                "personKeys": [this.state.data.staffDetails.personId]
            });
            whiteListLocationCollection = STAFF_DETAILS.locations.map(location => {
                location["active"] = false;
                return location;
            });
        };
        requestHandler
            .then(
                (_successLog) => {
                    const { refreshStaffList } = this.props;

                    this.getStaffDetails(staffDetails.personId, { softRefresh: true });
                    const responseData = [];
                    _successLog.successList.forEach(
                        (_successNodes) => {
                            responseData.push({
                                statusCode: _successNodes.statusCode,
                                text: `${_successNodes.email} status updated successfully.`
                            });
                        }
                    );
                    _successLog.errorList.forEach(
                        (_errorNodes) => {
                            responseData.push({
                                statusCode: _errorNodes.statusCode,
                                text: _errorNodes.statusMessage
                            });
                        }
                    );
                    this.requestStaffWhitelistSync(staffDetails.personId, whiteListLocationCollection).catch(
                        (e) => console.error(e)
                    );
                    this.setState({
                        response: {
                            ...this.state.response,
                            isOpen: true,
                            data: responseData
                        },
                        staffActivateDeactivateSubmitting: false,
                        deactivateConfirmOpen: false
                    });
                    setStaffDetails({});

                    if (refreshStaffList) {
                        refreshStaffList();
                    }
                },
                (_errorLog) => {
                    setStaffDetails({});
                    this.setState({
                        staffActivateDeactivateSubmitting: false,
                        deactivateConfirmOpen: false,
                        staffProfile: {
                            isOpen: false,
                            staffDetails: {}
                        },
                    });
                }
            );
    };

    /**
     * @name getRoleName
     * @desc Gets role name from props passed.
     * @return {string}
     */
    getRoleType = () => {
        if (!this.state.data.locations) {
            return null;
        }
        const role = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (this.props.staffRole) {
            return this.props.staffRole;
        }
        if (role) {
            return role.roleType;
        }
        return null;
    };

    /**
     * Returns the profile's role type from the active PLA (location with active: true in state.data.locations).
     * If no active location exists, uses the first location. Returns null if no locations exist.
     * Use for access matrix, tabs, and Add Facility (profile being viewed) without relying on selected location / props.
     * @return {string|null}
     */
    getProfileRoleTypeFromActiveLocation = () => {
        const locations = this.state.data?.locations;
        if (!locations || locations.length === 0) return null;
        const activeLocation = locations.find((loc) => loc.active === true);
        const location = activeLocation || locations[0];
        return location?.roleType ?? null;
    };

    /**
     * Freedom role name for the active PLA (`location.roleName` / `roles_ref.role_name`).
     * @return {string|null}
     */
    getProfileFreedomRoleNameFromActiveLocation = () => {
        const locations = this.state.data?.locations;
        if (!locations || locations.length === 0) return null;
        const activeLocation = locations.find((loc) => loc.active === true);
        const location = activeLocation || locations[0];
        return location?.roleName ?? null;
    };

    /**
     * @name isProfileModificationAllowed
     * @desc GET property which returns if user can modify profile or not.
     * @return {Boolean}
     */
    get isProfileModificationAllowed() {
        const staffId = this.getResolvedProfilePersonId();
        if (staffId == null || staffId === '') {
            return true;
        }
        return String(staffId) !== String(USER_CONTEXT.personId);
    };

    /**
     * @name whiteListStaff
     * @param {object} staffData
     * @desc White list's staff data if Auto_Create_Relationships is true.
     * @return {void}
     */
    whiteListStaff = async (staffData) => {
        try {
            await this.requestStaffWhitelistSync(staffData.personId, staffData.locations);
        } catch (e) {
            console.error(e);
        }
    };

    getIcon = (roleName) => {
        switch (roleName) {
            case "Attorney":
                /* eslint-disable sonarjs/no-clear-text-protocols -- SVG/XML namespace URIs are standard */
                return <svg xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    svgjs="http://svgjs.com/svgjs" version="1.1" width="45px" height="45px" x="0" y="0" viewBox="0 0 480.004 480.004"
                    space="preserve" class=""><g>
                        <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                                <path d="M479.202,292.692l0.072-0.024l-78.808-171.952l19.112-9.512l-7.152-14.32l-18.632,9.28l-2.52-5.496    c-1.842-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.248,4.912c-13.56-6.298-28.329-9.566-43.28-9.576    h-67.2v-16h16v-16H266.25l5.752-23.016c4.416-17.673-6.33-35.58-24.003-39.997c-17.673-4.416-35.58,6.33-39.997,24.003    c-1.312,5.25-1.312,10.743,0,15.993l5.752,23.016h-13.752v16h16v16h-67.16c-14.966,0.012-29.75,3.288-43.32,9.6l-2.248-4.912    c-1.841-4.016-6.59-5.779-10.606-3.938c-1.742,0.799-3.139,2.196-3.938,3.938l-2.52,5.496l-18.632-9.32l-7.152,14.336    l19.112,9.552L0.73,292.668c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80    c30.913-0.035,55.965-25.087,56-56c-0.02-1.149-0.293-2.28-0.8-3.312l-79.024-172.6c11.487-5.332,24-8.092,36.664-8.088h67.16    v292.688l-27.312,27.312h-28.688c-22.08,0.026-39.974,17.92-40,40c0,4.418,3.582,8,8,8h224c4.418,0,8-3.582,8-8    c-0.026-22.08-17.92-39.974-40-40h-28.688l-27.312-27.312V112.004h67.2c12.664-0.004,25.177,2.756,36.664,8.088L288.73,292.668    c-0.486,1.045-0.734,2.184-0.728,3.336c0.035,30.913,25.087,55.965,56,56h80c30.913-0.035,55.965-25.087,56-56    C479.983,294.855,479.71,293.724,479.202,292.692z M136.002,336.004h-80c-19.002-0.021-35.375-13.387-39.2-32h158.4    C171.378,322.617,155.004,335.983,136.002,336.004z M171.538,288.004H20.466l73.488-160.328c1.342,0.36,2.754,0.36,4.096,0    L171.538,288.004z M226.618,22.532c6.23-7.392,17.273-8.333,24.665-2.103c0.759,0.64,1.463,1.344,2.103,2.103    c3.236,4.116,4.379,9.5,3.096,14.576l-6.728,26.896H230.25l-6.728-26.896C222.239,32.032,223.383,26.648,226.618,22.532z     M232.002,96.004v-16h16v16H232.002z M248.002,112.004v288h-16v-288H248.002z M320.002,448.004    c10.168,0.012,19.229,6.418,22.632,16H137.37c3.403-9.582,12.464-15.988,22.632-16H320.002z M268.69,432.004h-57.376l16-16h25.376    L268.69,432.004z M381.938,127.7c1.321,0.465,2.77,0.405,4.048-0.168l73.552,160.472H308.466L381.938,127.7z M424.002,336.004h-80    c-19.002-0.021-35.375-13.387-39.2-32h158.4C459.378,322.617,443.004,335.983,424.002,336.004z" fill="white" data-original="#000000" />
                            </g>
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                        <g xmlns="http://www.w3.org/2000/svg">
                        </g>
                    </g></svg>;
                /* eslint-enable sonarjs/no-clear-text-protocols */

            case "Learner":
                return <UserIcon />;

            default:
                return <VerifiedUserIcon />;
        };
    };

    componentDidMount() {
        const { unleashProps } = this.props;
        if (unleashProps.isFlagEnabled()) {
            this.setHiddenBreadcrumbItems();
        }
        this.getStaffDetails(this.getResolvedProfilePersonId());
    };

    componentDidUpdate(nextProps, nextState) {
        const { unleashProps, staffData } = this.props;
        const { isstaffDetailsLoading, data } = this.state;
        const personId = getUserIdFromURL('users');
        const profileIdWhenFlagOff = staffData ? staffData.personId : personId;
        const profileId = unleashProps.isFlagEnabled()
            ? (this.global.staffProfileID || personId || staffData?.personId)
            : profileIdWhenFlagOff;

        if (Object.keys(data).length !== 0 && personId && parseInt(data.id) !== parseInt(personId)) {
            return this.getStaffDetails(personId);
        }
        if (!isstaffDetailsLoading && data.id !== profileId && this.props.isOpen) {
            this.getStaffDetails(profileId);
        }
    };

    /**
     * @name getGroupedData
     * @param {array} userLocations
     * @desc Group's user data by location name & status.
     * @return {array} userLocationsMutated
     */
    getGroupedData = (userLocations) => {
        const userLocationsMutated = [];
        if (!Array.isArray(userLocations)) {
            return userLocationsMutated;
        }
        userLocations.forEach(
            (location) => {
                const dataIndex = userLocationsMutated.findIndex(_location => location.locationName === _location.locationName && location.active === _location.active);
                if (dataIndex > -1) {
                    userLocationsMutated[dataIndex].roleName += `, ${location.roleName}`;
                } else {
                    userLocationsMutated.push(location);
                };
            }
        );
        return userLocationsMutated;
    };

    /**
     * @name getStaffDetails
     * @param {number} userId
     * @desc Fetches details by user ID.
     * @return {void}
     */

    setHiddenBreadcrumbItems = () => {
        this.setGlobal({
            hiddenBreadcrumbItems: [`Staff Profile/ ${Object.keys(this.TABS)[this.state.activeTab].split('_').join(' ')}`]
        });
    };

    /**
     * Resolves the person id for the profile currently being viewed (page + dialog modes).
     * staffProfileID is not always set when the route is /users/:id — URL / state must be used.
     */
    getResolvedProfilePersonId = () => {
        const { unleashProps, staffData } = this.props;
        const fromState = this.state.data?.staffDetails?.personId ?? this.state.data?.id;
        if (unleashProps.isFlagEnabled()) {
            const resolved =
                this.global.staffProfileID ||
                getUserIdFromURL('users') ||
                staffData?.personId ||
                fromState;
            return resolved !== undefined && resolved !== null && resolved !== '' ? resolved : null;
        }
        const resolved = staffData?.personId || getUserIdFromURL('users') || fromState;
        return resolved !== undefined && resolved !== null && resolved !== '' ? resolved : null;
    };

    /** Re-fetch profile after facilities mutations without clearing the UI or global loading (grid shows its own skeleton). */
    refreshStaffDetailsAfterFacilitiesChange = () =>
        this.getStaffDetails(this.getResolvedProfilePersonId(), { softRefresh: true });

    /**
     * @param {*} userID
     * @param {{ softRefresh?: boolean }} [options] When softRefresh is true (e.g. facilities grid mutations),
     *        keep showing current profile data and do not toggle global isLoading — avoids full-page flash.
     */
    getStaffDetails = (userID, options = {}) => {
        const softRefresh = options.softRefresh === true;
        const id = userID != null && userID !== '' ? userID : this.getResolvedProfilePersonId();
        if (id == null || id === '') {
            this.setGlobal({ isLoading: false });
            this.setState({ isstaffDetailsLoading: false });
            return Promise.resolve();
        }
        if (!softRefresh) {
            this.setGlobal({
                isLoading: true
            });
            this.setState({
                isstaffDetailsLoading: true,
                data: {}
            });
        }
        return getStaffDetails(id)
            .then(
                (_successLog) => {
                    this.setGlobal({
                        isLoading: false
                    });
                    const rawLocations = Array.isArray(_successLog.locations) ? _successLog.locations : [];
                    const createStaffV2Enabled = this.props.unleashProps?.getClient()?.isEnabled(UnleashService.FLAGS.CREATE_STAFF_V2);
                    const locationsForState = createStaffV2Enabled
                        ? rawLocations
                        : this.getGroupedData(rawLocations);
                    this.setState({
                        data: {
                            ..._successLog,
                            locations: locationsForState,
                            id
                        },
                        facilitiesLocations: rawLocations,
                        ...(!softRefresh ? { isstaffDetailsLoading: false } : {}),
                    });
                    this.getFeatures(this.getSelectedLocation, softRefresh ? { quiet: true } : undefined);
                    setStaffDetails({
                        ..._successLog,
                        locations: locationsForState,
                        id
                    });
                },
                (_errorLog) => {
                    this.setGlobal({
                        isLoading: false,
                        selectedUser: id,
                    });
                    if (!softRefresh) {
                        this.setState({ isstaffDetailsLoading: false });
                    }
                }
            );
    };

    /**
     * @name getSelectedLocation
     * @desc GET property to select user's active location.
     * @return {number} activeLocationId
     */
    get getSelectedLocation() {
        if (this.props.activeLocation) {
            return this.props.activeLocation;
        }
        const activeLocation = (this.state.data.locations || [])
            .find((location) => location.active);
        if (activeLocation) {
            return activeLocation.locationId;
        }
        if (this.state.data.locations && this.state.data.locations[0]) {
            return this.state.data.locations[0].locationId;
        }
        return undefined;
    };

    /**
    * @name getActiveStatus
    * @desc True if the **currently selected** facility row is active (not global across all facilities).
    * @return {boolean}
    */
    getActiveStatus = () => {
        if (!this.state.data.locations) {
            return false;
        }
        const role = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (role) {
            return role.active;
        }
        return false;
    };

    /**
     * @name staffHasAnyActiveLocation
     * @desc True if the staff member is active at **any** facility. Drives profile header
     * Activate vs Deactivate (Deactivate when any location is active; Activate when all are inactive).
     * @return {boolean}
     */
    staffHasAnyActiveLocation = () => {
        const locations = this.state.data.locations;
        if (!locations || !locations.length) {
            return false;
        }
        return locations.some((location) => location.active);
    };

    /**
     * @name handleStaffActivateDeactivateClick
     * @param {boolean} createStaffV2Enabled
     */
    handleStaffActivateDeactivateClick = (createStaffV2Enabled) => {
        const hasAnyActive = this.staffHasAnyActiveLocation();
        const profileRoleType = this.getProfileRoleTypeFromActiveLocation();
        const isViewingSuperAdminProfile =
            profileRoleType != null && SUPER_ADMIN_ROLES.includes(profileRoleType);
        const useV2ActivateDeactivateFlow = createStaffV2Enabled && !isViewingSuperAdminProfile;

        if (useV2ActivateDeactivateFlow) {
            if (!hasAnyActive) {
                // RoleAssignmentDialog lives under Facilities (RolesAssignments); mount that tab so the modal opens here.
                this.setState({
                    addFacilityDialogOpen: true,
                    addFacilityDialogForReactivation: true,
                    activeTab: this.TABS.Roles,
                });
            } else {
                this.setState({ deactivateConfirmOpen: true });
            }
        } else if (!hasAnyActive) {
            this.setState({
                activeTab: this.TABS.Details,
                staffActivateDeactivateSubmitting: true
            });
            this.changeStaffStatus(true);
        } else {
            this.setState({ deactivateConfirmOpen: true });
        }
    };

    closeDeactivateConfirmModal = () => {
        if (this.state.staffActivateDeactivateSubmitting) {
            return;
        }
        this.setState({ deactivateConfirmOpen: false });
    };

    confirmDeactivateUser = () => {
        this.setState({ staffActivateDeactivateSubmitting: true }, () => {
            this.changeStaffStatus(false);
        });
    };

    handleResponseDialog = (isOpen) => {
        this.setState({
            response: {
                ...this.state.response,
                isOpen
            }
        });
    };

    isActionsAllowed = (isAttorneyAllowed) => {
        return !(this.getRoleType() === ROLES.ATTORNEY && !isAttorneyAllowed);
    };

    getAttorneyData = () => {
        if (!STAFF_DETAILS.attorneyDetails) return null;
        const d = STAFF_DETAILS.attorneyDetails;
        return {
            phoneNumber: d.telephoneNumber ?? "",
            lawFirmName: d.lawFirmName ?? "",
            lawFirmAddress: d.address1 ?? "",
            lawFirmAddress2: d.address2 ?? "",
            lawFirmCity: d.city ?? "",
            lawFirmState: d.stateName ?? "",
            lawFirmZip: d.zipCode ?? "",
        };
    };

    /**
     * @name getActiveLocation
     * @desc Gets active location based upon props.
     * @return {object}
     */
    getActiveLocation = () => {
        if (!this.state.data.locations) {
            return {};
        }
        const location = this.state.data.locations
            .find((location) => location.locationId === this.getSelectedLocation);
        if (location) {
            return location;
        }
        return {};
    };

    /**
     * @name getFeatures
     * @param {number} locationId
     * @param {{ quiet?: boolean }} [options] quiet: do not toggle global isLoading (e.g. after facilities soft refresh).
     * @desc Fetches feature w.r.t to location.
     * @return {void}
     */
    getFeatures = async (locationId, options = {}) => {
        const quiet = options.quiet === true;
        if (!quiet) {
            this.setGlobal({
                isLoading: true
            });
        }
        try {
            const isAttorneyAllowed = await getLocationFeatureStatus(locationId, this._managementService.MessagingAttorney);
            const isAutoCreateAvailable = await getLocationFeatureStatus(locationId, this._managementService.AutoCreateRelationships);

            if (!quiet) {
                this.setGlobal({
                    isLoading: false,
                });
            }
            this.setState({
                isAttorneyAllowed: isAttorneyAllowed.status,
                isAutoCreateAvailable: isAutoCreateAvailable.status,
            });
        } catch (e) {
            console.error(e)
            if (!quiet) {
                this.setGlobal({
                    isLoading: false
                });
            }
        };
    };

    handleManageDialog = (isOpen, data = null) => {
        this.setState({
            manageStaff: {
                ...this.state.manageStaff,
                data,
                isOpen
            }
        });
    };

    handleConfirmationDialog = (isConfirmationOpen, data, description = "") => {
        const manageStaff = {
            ...this.state.manageStaff,
            description,
            isConfirmationOpen
        };
        if (isConfirmationOpen) {
            manageStaff["data"] = data;
        } else {
            manageStaff["data"] = null;
        }
        this.setState({
            manageStaff
        });
    }

    onCloseHandler = () => {
        this.setState({
            activeTab: this.TABS.Details,
            data: {}
        });
        setStaffDetails({});
        setUserCommunicationContactsData(null);
        this.setGlobal({
            staffProfileID: null,
            staffSelectedLocation: null,
            isStaffProfileOpen: false
        });
        if (this.props.onCloseHandler) {
            this.props.onCloseHandler();
        }
    };

    /** True when the open profile is the signed-in admin (Facilities grid: hide row actions for self). */
    isViewingOwnProfile = () => {
        const profileId = this.getResolvedProfilePersonId();
        return profileId != null && String(profileId) === String(USER_CONTEXT.personId);
    };

    /**
     * Add Facility button visibility per access matrix.
     * Facility Staff (matrix) = Teacher in code (global.isTeacher) — signed-in teachers never see Add Facility.
     * - Superadmin viewing Superadmin profile: No Add Facility.
     * - Facility Admin viewing any other profile (except Superadmin): Show.
     * - Superadmin viewing other profile: Show when profile is Staff/Messaging/Attorney/Teacher (facility staff).
     * - Signed-in Facility Staff (Teacher): Hide in all cases.
     */
    shouldShowAddFacilityButton = () => {
        if (this.global.isTeacher) return false;
        const isViewingOwnProfile = this.isViewingOwnProfile();
        const roleType = this.getProfileRoleTypeFromActiveLocation();
        if (this.global.isSuperAdmin && !isViewingOwnProfile && SUPER_ADMIN_ROLES.includes(roleType)) return false;
        if (isViewingOwnProfile) return false;
        if (this.global.isFacilityAdmin && !isViewingOwnProfile && !SUPER_ADMIN_ROLES.includes(roleType)) return true;
        if (this.global.isSuperAdmin && !isViewingOwnProfile) {
            return [ROLES.STAFF, ROLES.MESSAGING_ONLY, ROLES.ATTORNEY, ROLES.TEACHER].includes(roleType);
        }
        return false;
    };

    /**
     * Facilities tab: header (V2) + RolesAssignments. Split out to keep RenderStaffDetails .
     */
    renderRolesAssignmentsSection = (createStaffV2Enabled, classes) => {
        const isUserActive = this.getActiveStatus();
        const rawLocs = this.state.facilitiesLocations || [];
        const plaRoleId = (rawLocs.find(l => l.active) ?? rawLocs[0])?.roleId ?? null;
        const { refreshStaffList: listRefreshFromParent } = this.props;
        const refreshStaffListForFacilitiesTab =
            createStaffV2Enabled && typeof listRefreshFromParent === 'function'
                ? () => listRefreshFromParent({ quiet: true })
                : listRefreshFromParent;

        const v2FacilityProps = createStaffV2Enabled
            ? {
                  addButtonLabel: 'Add Facility',
                  addFacilityDialogOpen: this.state.addFacilityDialogOpen,
                  addFacilityDialogForReactivation: this.state.addFacilityDialogForReactivation,
                  onAddFacilityDialogClose: () =>
                      this.setState({
                          addFacilityDialogOpen: false,
                          addFacilityDialogForReactivation: false,
                      }),
                  onReactivationFacilitySubmit: this.runReactivationViaAddFacilityFlow,
                  facilitiesLocations: rawLocs,
                  plaRoleId,
                  isUserActive,
                  onFacilitiesRefresh: this.refreshStaffDetailsAfterFacilitiesChange,
              }
            : {};

        return (
            <>
                {createStaffV2Enabled && (
                    <Box className={classes.facilitiesSectionHeader}>
                        <Box>
                            <Typography component="h2" className={classes.facilitiesHeading}>
                                Facilities
                            </Typography>
                            <Typography className={classes.facilitiesExplainer}>
                                This user will be able to access learners across all of the following facilities.
                            </Typography>
                        </Box>
                        {isUserActive && this.shouldShowAddFacilityButton() && (
                            <PermissionControl permissionName="Assign_Admin_To_Different_Location">
                                <Button
                                    className={classes.addFacilityBtn}
                                    color="primary"
                                    variant="contained"
                                    onClick={() =>
                                        this.setState({
                                            addFacilityDialogOpen: true,
                                            addFacilityDialogForReactivation: false,
                                        })
                                    }
                                >
                                    Add Facility
                                </Button>
                            </PermissionControl>
                        )}
                    </Box>
                )}
                <RolesAssignments
                    isActionAllowed={this.isProfileModificationAllowed}
                    userDetail={this.state.data.staffDetails}
                    roleName={this.getProfileRoleTypeFromActiveLocation()}
                    refreshStaffList={refreshStaffListForFacilitiesTab}
                    createStaffV2Enabled={createStaffV2Enabled}
                    isViewingOwnProfile={this.isViewingOwnProfile()}
                    {...v2FacilityProps}
                />
            </>
        );
    };

    staffProfileTabIconByName = {
        flag: FlagIcon,
        group: GroupIcon,
    };

    /**
     * Icon for V2 staff profile tabs (security uses on/off by selection).
     */
    getStaffProfileTabIcon = (item, createStaffV2Enabled, isSelected) => {
        if (!createStaffV2Enabled || !item.icon) {
            return null;
        }
        if (item.icon === 'security') {
            return isSelected ? ToggleOn : ToggleOff;
        }
        return this.staffProfileTabIconByName[item.icon] ?? null;
    };

    staffProfileTabRootClassName = (createStaffV2Enabled, isSelected, classes) =>
        createStaffV2Enabled
            ? [classes.tabButton, isSelected ? '' : classes.tabButtonInactive].filter(Boolean).join(' ')
            : [classes.tabButtonLegacy, isSelected ? classes.selectedTabButtonLegacy : ''].filter(Boolean).join(' ');

    /**
     * Single tab button for staff profile (extracted to satisfy cognitive-complexity limits on RenderStaffDetails).
     */
    renderStaffProfileTab = (item, activeTab, createStaffV2Enabled, classes) => {
        const isSelected = activeTab === item.id;
        const Icon = this.getStaffProfileTabIcon(item, createStaffV2Enabled, isSelected);
        const rootClassName = this.staffProfileTabRootClassName(createStaffV2Enabled, isSelected, classes);

        return (
            <Tab
                key={item.id}
                classes={{
                    root: rootClassName,
                    selected: createStaffV2Enabled ? classes.selectedTabButton : classes.selectedTabButtonLegacy,
                    wrapper: createStaffV2Enabled ? classes.tabIconLabel : undefined
                }}
                label={
                    Icon ? (
                        <span className={classes.tabLabelWithIcon}>
                            <Icon className={isSelected ? classes.tabIconActive : classes.tabIconInactive} />
                            {item.label}
                        </span>
                    ) : (
                        item.label
                    )
                }
                value={item.id}
            />
        );
    };

    RenderStaffDetails = () => {
        const { classes, unleashProps } = this.props;
        const locationAssignment = (isPermitted(this.global.cbacConfigFlag, this.global.permissions, "Assign_Admin_To_Different_Location", this.global.permissionIds))
        const unassignAdminToDifferentLoc = isPermitted(this.global.cbacConfigFlag, this.global.permissions, "Unassign_Admin_From_Different_Location", this.global.permissionIds)
        const profileId = this.getResolvedProfilePersonId();
        const isDisableV1MessagingEnabled = unleashProps.getClient()?.isEnabled(UnleashService.FLAGS.DISABLE_V1_MESSAGING);
        const createStaffV2Enabled = unleashProps.getClient()?.isEnabled(UnleashService.FLAGS.CREATE_STAFF_V2);
        const TABS = useTabDetailsHook({
            profileId,
            allTabs: this.TABS,
            global: this.global,
            isDisableV1MessagingEnabled,
            freedomRoleName: this.getProfileFreedomRoleNameFromActiveLocation(),
            createStaffV2Enabled
        });
        const tabIds = TABS.map(t => t.id);
        const fallbackTab = tabIds[0] !== undefined ? tabIds[0] : this.TABS.Details;
        const activeTab = tabIds.length > 0 && !tabIds.includes(this.state.activeTab)
            ? tabIds[0]
            : (this.state.activeTab ?? fallbackTab);

        return (
            <>
                {this.state.data.staffDetails && (
                    <>
                        <Box
                            width="100%"
                        >
                            <ResponseBox
                                heading={this.state.response.heading}
                                isOpen={this.state.response.isOpen}
                                onClose={() => {
                                    this.handleResponseDialog(false);
                                }}
                                data={this.state.response.data}
                                groupedView={false}
                            />
                            {this.state.deactivateConfirmOpen && (
                                <Modal
                                    open
                                    onClose={this.closeDeactivateConfirmModal}
                                    onContinue={this.confirmDeactivateUser}
                                    actionBtnText="Deactivate"
                                    cancelBtnText="Cancel"
                                    showCrossIcon={!this.state.staffActivateDeactivateSubmitting}
                                    disableBackdropClick={this.state.staffActivateDeactivateSubmitting}
                                    continueButtonProps={{
                                        disabled: this.state.staffActivateDeactivateSubmitting,
                                        startIcon: this.state.staffActivateDeactivateSubmitting ? (
                                            <CircularProgress size={20} color="inherit" />
                                        ) : undefined,
                                    }}
                                    cancelButtonProps={{
                                        disabled: this.state.staffActivateDeactivateSubmitting,
                                    }}
                                    labelledBy="deactivate-staff-account-title"
                                    describedBy="deactivate-staff-account-description"
                                    Icon={<LockPersonOutlined className={classes.deactivateConfirmLockPersonIcon} />}
                                    modalType={{ type: 'confirmation', status: 'danger', size: 'medium' }}
                                    styles={deactivateConfirmModalSlotStyles}
                                >
                                    <CommonsTypography
                                        id="deactivate-staff-account-title"
                                        component="h2"
                                        variant="h5"
                                        className={classes.deactivateConfirmHeadline}
                                    >
                                        Are you sure you want to deactivate this account?
                                    </CommonsTypography>
                                    <CommonsTypography
                                        id="deactivate-staff-account-description"
                                        component="p"
                                        variant="body1"
                                        className={classes.deactivateConfirmDescription}
                                    >
                                        Once an account is deactivated, the user will lose access to the account.
                                    </CommonsTypography>
                                </Modal>
                            )}
                            <ManageStaffContainer
                                {...this.state.manageStaff}
                                isEdit={true}
                                isAttorneyAllowed={this.state.isAttorneyAllowed}
                                isAutoCreateAvailable={this.state.isAutoCreateAvailable}
                                refresh={() =>
                                    this.getStaffDetails(this.getResolvedProfilePersonId(), { softRefresh: true })
                                }
                                activeLocation={this.getActiveLocation().locationId}
                                handleManageDialog={this.handleManageDialog}
                                formDialogData={JSON.stringify(this.state.manageStaff.data)}
                                isPermissionAllowed={locationAssignment}
                                AssignedToDiffLocation={locationAssignment}
                                UnassignedToDiffLocation={unassignAdminToDifferentLoc}
                                refreshStaffList={this.props.refreshStaffList}

                            />
                            <Paper className={[classes.userProfileWrapper, !unleashProps.isFlagEnabled() ? classes.profileMargin : ''].join(" ")}>
                                <Grid container item md={12}>

                                    <Grid container
                                        alignItems="center"
                                        item md={6} >
                                        <Box component="div">
                                            <Box
                                                className={classes.blueIconContainer}
                                                component="div">
                                                {this.getIcon(this.getProfileRoleTypeFromActiveLocation())}
                                                {/* <img
                                             width="45px"
                                             src="/assets/icons/balance-scale.png" /> */}
                                            </Box>
                                        </Box>
                                        <Box
                                            className={classes.userProfileInfoWrapper}
                                            component="div" display="flex" flexDirection="column">
                                            <Typography className={classes.userProfileHeading}>
                                                {this.state.data.staffDetails.displayName ? this.state.data.staffDetails.displayName : this.state.data.staffDetails.firstName + " " + this.state.data.staffDetails.lastName}                                            </Typography>
                                            <Box component="div" display="flex" flexDirection="row" alignItems="center">
                                                <Typography className={classes.userId}>
                                                    {this.getProfileRoleTypeFromActiveLocation()}
                                                </Typography>
                                                <SSOEnabledChip enabled={Boolean(this.state.data?.isSSOEnrolled)} />
                                            </Box>

                                        </Box>
                                    </Grid>


                                    <Grid container
                                        direction="row"
                                        alignItems="center"
                                        justify="flex-end"
                                        className={classes.actionContainer}
                                        item md={6}>
                                        {this.isProfileModificationAllowed && (
                                            <>
                                                <PermissionControl
                                                    permissionName="Edit_Admins_Information"
                                                    forceRestriction={this.props.isAttorneyAllowed}
                                                >
                                                    <PillButton
                                                        variant="outlined"
                                                        color="primary"
                                                        className={classes.profileHeaderPillButton}
                                                        onClick={() => {
                                                            const splitDisplayName = this.state.data.staffDetails.displayName.split(" ");
                                                            this.setState({
                                                                activeTab: this.TABS.Details
                                                            });
                                                            this.handleManageDialog(true, {
                                                                personId: this.state.data.staffDetails.personId,
                                                                title: this.state.data.staffDetails.title || "",
                                                                password: this.state.data.staffDetails.password || "",
                                                                firstName: this.state.data.staffDetails.firstName,
                                                                email: this.state.data.staffDetails.email,
                                                                lastName: this.state.data.staffDetails.lastName,
                                                                rolesAtLocation: this.state.data.locations,
                                                                displayFirstName: splitDisplayName.length > 0 ? splitDisplayName[0] : "",
                                                                displayLastName: splitDisplayName.length > 1 ? splitDisplayName[1] : "",
                                                                ...this.state.data.attorneyDetails
                                                            });
                                                        }}
                                                    >
                                                        Edit Details
                                                    </PillButton>
                                                </PermissionControl>

                                                <PermissionControl
                                                    permissionName="Inactivate/Reactivate_Staff"
                                                >
                                                    <PillButton
                                                        variant="outlined"
                                                        color={this.staffHasAnyActiveLocation() ? "error" : "inherit"}
                                                        className={[
                                                            classes.profileHeaderPillButton,
                                                            !this.staffHasAnyActiveLocation() ? classes.profileHeaderReactivatePillButton : '',
                                                        ].filter(Boolean).join(' ')}
                                                        disabled={
                                                            this.state.staffActivateDeactivateSubmitting ||
                                                            this.state.deactivateConfirmOpen
                                                        }
                                                        startIcon={
                                                            this.state.staffActivateDeactivateSubmitting &&
                                                            !this.staffHasAnyActiveLocation() ? (
                                                                <CircularProgress size={16} color="inherit" />
                                                            ) : undefined
                                                        }
                                                        onClick={() => this.handleStaffActivateDeactivateClick(createStaffV2Enabled)}
                                                    >
                                                        {this.staffHasAnyActiveLocation() ? "Deactivate User" : "Reactivate User"}
                                                    </PillButton>
                                                </PermissionControl>
                                            </>
                                        )}
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Box>
                        <Box margin="20px 15px">
                            {TABS.length > 0 && (
                                <Box marginBottom="20px">
                                    <Tabs
                                        classes={{
                                            indicator: createStaffV2Enabled ? classes.tabIndicator : classes.tabIndicatorLegacy,
                                            root: createStaffV2Enabled ? classes.tabContainer : classes.tabContainerLegacy
                                        }}
                                        value={activeTab}
                                        onChange={(event, newVal) => { this.handleTabChange(newVal) }}
                                    >
                                        {TABS.filter((item) => !item.permissionName || isPermitted(this.global.cbacConfigFlag, this.global.permissions, item.permissionName))
                                            .map((item) => this.renderStaffProfileTab(item, activeTab, createStaffV2Enabled, classes))}
                                    </Tabs>
                                </Box>
                            )}
                            {TABS.length > 0 && activeTab === this.TABS.Relationship && (
                                <LearnerRelationship
                                    isActionAllowed={this.isProfileModificationAllowed}
                                    isStaff={true}
                                    setResponse={(response) => this.setState({
                                        response
                                    })}
                                    userDetail={{
                                        userName: this.state.data.staffDetails.email,
                                        displayName: `${this.state.data.staffDetails.firstName} ${this.state.data.staffDetails.lastName}`,
                                        role: this.getProfileRoleTypeFromActiveLocation(),
                                        userId: this.state.data.staffDetails.personId
                                    }}
                                    locations={STAFF_DETAILS.locations}
                                    profileUserId={this.state.data.staffDetails.personId}
                                />
                            )}
                            {TABS.length > 0 && activeTab === this.TABS.Details && (
                                <StaffDetails
                                    open={this.props.isOpen}
                                    {...this.state.data}
                                    roleType={this.getProfileRoleTypeFromActiveLocation()}
                                />
                            )}
                            {TABS.length > 0 && activeTab === this.TABS.Communication && (
                                <UserCommunication
                                    isActionAllowed={this.isProfileModificationAllowed}
                                    type={COMMUNICATION_TAB_TYPE.Staff}
                                    userLocations={STAFF_DETAILS.locations}
                                    userActiveLocation={this.getActiveLocation()}
                                    history={this.props.history}
                                    profileUser={this.state.data.staffDetails}
                                />
                            )}
                            {TABS.length > 0 &&
                                activeTab === this.TABS.Roles &&
                                this.renderRolesAssignmentsSection(createStaffV2Enabled, classes)}
                            {TABS.length > 0 && activeTab === this.TABS.Learner_Group && (
                                <LearnerGroup />
                            )}
                            {activeTab === this.TABS.Permissions && createStaffV2Enabled && this.state.data.staffDetails && (
                                <StaffPermissionsTab
                                    personId={this.state.data.staffDetails.personId}
                                    hasActiveLocation={this.staffHasAnyActiveLocation()}
                                    canEdit={Boolean(this.global.isSuperAdmin || this.global.isSystemAdmin)}
                                    onSaveSuccess={() =>
                                        this.getStaffDetails(this.state.data.staffDetails.personId, {
                                            softRefresh: true,
                                        })
                                    }
                                />
                            )}
                            {TABS.length > 0 && activeTab === this.TABS.Sisense && (
                                <SisenseDashboard />
                            )}
                        </Box>
                    </>
                )
                }
            </>
        );
    }

    render() {
        const { unleashProps, classes } = this.props;
        return (
            <>
                <UnleashProvider flagName={UnleashService.FLAGS.STAFF_PROFILE_UI_PAGE}>
                    <this.RenderStaffDetails />
                </UnleashProvider>

                {!unleashProps.isFlagEnabled() &&
                    <Dialog
                        classes={{
                            paper: [classes.paper, "scroller-view"].join(" ")
                        }}
                        fullScreen open={this.props.isOpen} onClose={() => this.onCloseHandler()}>

                        {this.state.data.staffDetails && (
                            <>
                                <AppBar>
                                    <Toolbar>
                                        <IconButton edge="start" color="inherit" onClick={() => {
                                            this.onCloseHandler()
                                        }} aria-label="Close">
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography variant="h6" style={{ flexGrow: 1, color: 'white' }}>
                                            {this.state.data.staffDetails.firstName} {this.state.data.staffDetails.lastName}
                                        </Typography>
                                    </Toolbar>
                                </AppBar>
                                <this.RenderStaffDetails />
                            </>
                        )}
                    </Dialog>
                }
            </>
        )
    }
}

export default withStyles(styles)(withUnleash(StaffProfile, UnleashService.FLAGS.STAFF_PROFILE_UI_PAGE));
